import { GlitzClient } from "@glitz/core";

const glitz = new GlitzClient();

// Injectera globala stilar
glitz.injectGlobals({
  html: {
    minHeight: "100%",
  },
  body: {
    margin: 0,
    padding: 0,
    minHeight: "100%",
    fontFamily: "avenir next, sans-serif",
    backgroundColor: "#f9f9f9",
  },
  "#root": {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
});

export default glitz;
